import { Button } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { useLocation } from "react-router"
import { parentFind } from "library/tree/index.mjs"
import { PlanRoot } from "library/tree/constants.mjs"

export function DownloadSchedulePDFButton({ onPrint }) {
    const { schedule, schedulePath, parentItem } = useBoundContext()
    const { search } = useLocation()
    const planRoot = parentFind(parentItem, (c) => c[PlanRoot])

    return (
        !!planRoot && (
            <Button
                variant="outlined"
                size="small"
                onClick={handlePdfDownload}
                startIcon={<Iconify icon="ic:round-print" />}
                data-cy="download-schedule-pdf-button"
                sx={{ mr: 2.5 }}
            >
                Print Schedule
            </Button>
        )
    )

    function handlePdfDownload() {
        onPrint?.({ schedule, planRoot })
        const scheduleURL = encodeURI(schedulePath + search)
        const url = `${window.location.protocol}//${window.location.host}/print/facilities/schedule/${scheduleURL}&schedulePrint=true&print=true&theme=light`
        window.open(url, "_blank")
    }
}
